import { ModifiersPayload } from 'controllers/SearchController/types';
import { FiltersParams } from 'types/params';
import getActiveFilter from './getActiveFilter';

const getActiveFilters = (
    queryKey: FiltersParams,
    filters: string[] | null,
    removeFilter: (modifiers: ModifiersPayload[]) => void,
) => {
    if (!filters) {
        return null;
    }

    return filters.map((filter: string) => {
        if (!filter) {
            return null;
        }

        return getActiveFilter(queryKey, filter, removeFilter);
    });
};

export default getActiveFilters;
